/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { O5DanteV1DeadMessageEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const O5_DANTE_V1_DEAD_MESSAGE_EVENT_ENTITY_NAME = 'o5.dante.v1.DeadMessageEvent';
export const o5DanteV1DeadMessageEventEntity = new schema.Entity<O5DanteV1DeadMessageEvent>(O5_DANTE_V1_DEAD_MESSAGE_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: O5DanteV1DeadMessageEvent) => `${entity.metadata?.eventId}` });

